import React, { Component } from 'react';

import { withCookies } from 'react-cookie';
import {withTranslation} from "react-i18next";

class Disclaimer extends  Component{

    render() {
        const { t } = this.props;
        return (
            <div id="gvlrgdisclaimer" className="vehicle-disclamer">
                <h5>{t("app.disclaimerheading")}</h5>

                <p>{t("app.disclaimertext")}</p>
            </div>
        );
    }

}

const cookieWrap = withCookies(Disclaimer);
export default withTranslation()(cookieWrap);